import React from 'react';
import type {AppearanceOptions} from '@stripe-internal/embedded-theming';

export type IThemingContext = AppearanceOptions;

export const ThemingContext = React.createContext<IThemingContext | undefined>(
  undefined,
);
ThemingContext.displayName = 'ThemingContext';

export const useTheming = (): IThemingContext | undefined => {
  return React.useContext(ThemingContext);
};
